import React from "react";
import { ContentMaker } from "./style";

const PurposeSummary = ({
  missionaryName,
  missionaryLocation,
  eventName,
  projectName,
  additionalComments
}) => {

  const renderFields = {
    "Missionary Name": missionaryName,
    "Missionary Location": missionaryLocation,
    "Project Name": projectName,
    "Event Name": eventName
  };

  return (
    <>
      {Object.keys(renderFields).map(
        (field, index) =>
          renderFields[field] && (
            <div
              key={field + index}
            >{`${field} - ${renderFields[field]}.`}</div>
          )
      )}
      {(renderFields['Missionary Name'] || renderFields['Missionary Location']) ?
        <ContentMaker className="mt-20">
          {additionalComments ? additionalComments : "No additional comments."}
        </ContentMaker> : <div>{additionalComments ? additionalComments : "No additional comments."}</div>
      }
    </>
  );
};

export default PurposeSummary;
